export default "__VITE_ASSET__Cwtay9wi__"